import React from 'react';
import { useHistory } from 'react-router';

import BoxContainer from 'components/BoxContainer';
import Listagem, { IRow } from 'components/Listagem';

import { Container, TitleHolder, ListHolder } from '../styles';

const SetoresCliente: React.FC = () => {
  const history = useHistory();

  const rows: IRow[] = [
    {
      label: '#',
      data: 'id',
    },
    {
      label: 'Nome',
      data: 'nome',
    },
  ];

  return (
    <Container>
      <TitleHolder>
        Setores de Cliente:
        <button
          type="button"
          onClick={() => history.push('/cadastros/setores-cliente/novo')}
        >
          Novo setor
        </button>
      </TitleHolder>
      <ListHolder>
        <BoxContainer borderColor="quaternary">
          <Listagem
            rows={rows}
            module="setores-cliente"
            moduleLabel="setores de cliente"
            template="100px 4fr"
            editUrl="/cadastros/setores-cliente/setor-cliente"
            indexUrl="/cadastros/setores-cliente/setor-cliente"
            deleteUrl="/setores-cliente/setor-cliente"
          />
          {/* <PaginationHolder>
            div.
          </PaginationHolder> */}
        </BoxContainer>
      </ListHolder>
    </Container>
  );
};

export default SetoresCliente;
